import React from 'react';
import { useLocation } from 'react-router-dom';
import DrawManagement from './DrawManagement';
import DrawDetails from './DrawDetails';

const DrawsRouter = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const drawId = params.get('draw_id');

  if (drawId) {
    return <DrawDetails />;
  }

  return <DrawManagement />;
};

export default DrawsRouter;

